import { Breadcrumb } from "./Breadcrumb";
import BtnBack from "./BtnBack";

export const About = () => {
  return (
    <div className="container my-5">
      <Breadcrumb current="¿Cómo solicitar un plebiscito?" />
      <div className="row mb-5">
        <div className="col-12 d-flex justify-content-center">
          <img
            src={require("../assets/como-solicito-un-plebiscito-titulo-2026.png")}
            className="img-fluid mb-3"
            alt="¿Cómo solicito un plebiscito?"
          />
        </div>
        <div className="row images">
          <div className="col-md-8 p-3">
            <img
              src={require("../assets/tabla-2025.png")}
              className="img-fluid mb-3"
              alt="¿Cómo solicito un plebiscito?"
            />
          </div>
          <div className="col-md-4 p-3">
            <div className="d-flex flex-column">
              <img
                src={require("../assets/porcentaje-2026.png")}
                className="img-fluid mb-4"
                alt="Porcentaje de firmas para solicitar un plebiscito"
              />
              <img
                src={require("../assets/plazos-2026.png")}
                className="img-fluid"
                alt="Plazos para solicitar un plebiscito"
              />
            </div>
          </div>
          <div className="">
            <img
              id="img-padron"
              src={require("../assets/PADRON-Y-LISTA-2026.png")}
              className="img-fluid w-50 mx-auto d-block"
              alt="Padrón y lista nominal 2025"
            />
          </div>
        </div>
      </div>
      <BtnBack />
    </div>
  );
};
